import { render } from "./EditDependent.vue?vue&type=template&id=7aa417c8"
import script from "./EditDependent.vue?vue&type=script&lang=js"
export * from "./EditDependent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__